import { render, staticRenderFns } from "./FrontOfNationalDesktopSvg.vue?vue&type=template&id=2bfec7c7&"
import script from "./FrontOfNationalDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./FrontOfNationalDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports